<template>
    <el-select v-model="Value" value-key="name" placeholder="请选择" popper-class="method-select" filterable allow-create>
      <el-option
        v-for="item in options"
        :key="item.name"
        :label="item.name"
        :value="item">
        <span>{{ item.name }}</span>
        <br/>
        <span style="color: #8492a6; font-size: 13px">{{ item.description }}</span>
      </el-option>
    </el-select>
	
</template>
<script>
import {methods} from '@/json/method'
export default {
  name: 'method-selector',
  props: {
    value: {
      type: [Object,String],
      default: ()=>null
    }
  },
  data () {
    return {
      Value: this.value,
      options: methods
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    getOptions () {
      // let options = []
      this.$store.dispatch('getMethodList').then(res => {
        // res.data.forEach(ele => {
        //   let obj = {
        //     label: ele.description,
        //     value: ele.name
        //   }
        //   options.push(obj)
        // })
        this.options = res.data
      })
    }
  },
  created () {
    this.getOptions()
  }
}
</script>
<style lang="less">
.method-select{
    .el-select-dropdown__item{
      padding: 10px;
      height:60px;
      line-height:20px;
    }
}
</style>
